import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  url = new BehaviorSubject('');

  // eslint-disable-next-line complexity
  constructor() {
    if (localStorage.getItem('userPermission')) {
      sessionStorage.setItem('userPermission', localStorage.getItem('userPermission'));
    }
    if (localStorage.getItem('devicePermission')) {
      sessionStorage.setItem('devicePermission', localStorage.getItem('devicePermission'));
    }
    if (localStorage.getItem('deplyPermission')) {
      sessionStorage.setItem('deplyPermission', localStorage.getItem('deplyPermission'));
    }
    if (localStorage.getItem('name')) {
      sessionStorage.setItem('name', localStorage.getItem('name'));
    }
    if (localStorage.getItem('email')) {
      sessionStorage.setItem('email', localStorage.getItem('email'));
    }
    if (localStorage.getItem('avatarUri')) {
      sessionStorage.setItem('avatarUri', localStorage.getItem('avatarUri'));
    }
    if (localStorage.getItem('isAdmin')) {
      sessionStorage.setItem('isAdmin', localStorage.getItem('isAdmin'));
    }
    if (localStorage.getItem('authToken')) {
      sessionStorage.setItem('authToken', localStorage.getItem('authToken'));
    }
    if (localStorage.getItem('deviceKnown')) {
      sessionStorage.setItem('deviceKnown', localStorage.getItem('deviceKnown'));
    }
    if (localStorage.getItem('deviceId')) {
      sessionStorage.setItem('deviceId', localStorage.getItem('deviceId'));
    }
  }

  public retrieveAuthToken = (): string => {
    return sessionStorage.getItem('authToken');
  };
  public storePersistentlyAuthToken = (token: string): void => {
    localStorage.setItem('authToken', token);
  };

  public storeAuthToken = (token: string): void => {
    sessionStorage.setItem('authToken', token);
  };

  public retrieveIsAdmin = (): boolean => {
    return sessionStorage.getItem('isAdmin') === 'true';
  };
  public storeIsAdmin = (isAdmin: boolean): void => {
    localStorage.setItem('isAdmin', isAdmin.toString());
    sessionStorage.setItem('isAdmin', isAdmin.toString());
  };

  public retrieveAvatarUri = (): string => {
    return sessionStorage.getItem('avatarUri');
  };

  setUrl = (param: string): void => {
    const url = param.toString();
    localStorage.setItem('ai', url);
    this.setUrlReload(url);
  };

  getUrl() {
    return localStorage.getItem('ai');
  }

  setCategoryId(id: string) {
    localStorage.setItem('ci', id.toString());
  }

  getCategoryId() {
    return localStorage.getItem('ci');
  }

  public getDeviceId = (): string => {
    return localStorage.getItem('deviceId');
  };
  public getDeviceName = (): string => {
    return localStorage.getItem('deviceName');
  };

  public getListDevicesSession = (): any => {
    const data = sessionStorage.getItem('listDevices');
    if (data) {
      return JSON.parse(data);
    } else {
      return [];
    }
  };
  public saveListDevicesSession = (listDevices): void => {
    sessionStorage.setItem('listDevices', JSON.stringify(listDevices));
  };

  setDeviceId(mode: any) {
    localStorage.setItem('deviceId', mode.toString());
  }

  setDeviceName(mode: any) {
    localStorage.setItem('deviceName', mode.toString());
  }

  setViewTable(mode: boolean) {
    localStorage.setItem('viewTable', mode.toString());
  }

  getViewTable() {
    return localStorage.getItem('viewTable');
  }

  public storeAvatarUri = (avatarUri: string): void => {
    localStorage.setItem('avatarUri', avatarUri);
    sessionStorage.setItem('avatarUri', avatarUri);
  };

  public retrieveEmail = (): string => {
    return sessionStorage.getItem('email');
  };
  getNoLicenseWarning() {
    return localStorage.getItem('noModalExpired') === 'true';
  }

  public storeEmail = (email: string): void => {
    localStorage.setItem('email', email);
    sessionStorage.setItem('email', email);
  };

  public retrieveName = (): string => {
    return sessionStorage.getItem('name');
  };

  public storeName = (name: string): void => {
    localStorage.setItem('name', name);
    sessionStorage.setItem('name', name);
  };

  public retrieveDeplyPermission = (): boolean => {
    return sessionStorage.getItem('deplyPermission') === 'true';
  };

  public storeDeplyPermission = (deplyPermission: boolean): void => {
    localStorage.setItem('deplyPermission', deplyPermission.toString());
    sessionStorage.setItem('deplyPermission', deplyPermission.toString());
  };

  public retrieveDevicePermission = (): boolean => {
    return sessionStorage.getItem('devicePermission') === 'true';
  };

  public storeDevicePermission = (devicePermission: boolean): void => {
    localStorage.setItem('devicePermission', devicePermission.toString());
    sessionStorage.setItem('devicePermission', devicePermission.toString());
  };

  public retrieveUserPermission = (): boolean => {
    return sessionStorage.getItem('userPermission') === 'true';
  };

  public storeUserPermission = (userPermission: boolean): void => {
    localStorage.setItem('userPermission', userPermission.toString());
    sessionStorage.setItem('userPermission', userPermission.toString());
  };

  public retrieveListPagination = (view?: string): string => {
    if (view === undefined) {
      view = '';
    }
    return sessionStorage.getItem('listPagination' + view);
  };

  public storeListPagination = (pagination: string, view?: string): void => {
    if (view === undefined) {
      view = '';
    }
    sessionStorage.setItem('listPagination' + view, pagination);
  };

  public retrieveListSorting = (view?: string): string => {
    if (view === undefined) {
      view = '';
    }
    return sessionStorage.getItem('listSorting' + view);
  };

  public storeListSorting = (sorting: string, view?: string): void => {
    if (view === undefined) {
      view = '';
    }
    sessionStorage.setItem('listSorting' + view, sorting);
  };

  public retrieveListSearch = (view?: string): string => {
    if (view === undefined) {
      view = '';
    }
    return sessionStorage.getItem('listSearch' + view) ?? '';
  };

  public storeListSearch = (search: string, view?: string): void => {
    if (view === undefined) {
      view = '';
    }
    sessionStorage.setItem('listSearch' + view, search);
  };

  public retrieveListTags = (): string[] => {
    return JSON.parse(sessionStorage.getItem('listTags')) || [];
  };

  setInputType(mode: any) {
    localStorage.setItem('typeInput', mode.toString());
  }

  clearInputType() {
    localStorage.removeItem('typeInput');
  }

  getInputType() {
    return localStorage.getItem('typeInput');
  }

  public storeListTags = (tags: string[]): void => {
    sessionStorage.setItem('listTags', JSON.stringify(tags));
  };

  setNoLicenseWarning(show: any) {
    localStorage.setItem('noModalExpired', show.toString());
  }

  public retrieveListSelection = (): string[] => {
    return JSON.parse(sessionStorage.getItem('listSelection')) || [];
  };

  public storeListSelection = (selection: string[]): void => {
    sessionStorage.setItem('listSelection', JSON.stringify(selection));
  };

  public retrieveDeviceKnown = (): boolean => {
    return JSON.parse(sessionStorage.getItem('deviceKnown')) === true;
  };

  public retrievePersistentlyDeviceKnown = (): boolean => {
    return JSON.parse(localStorage.getItem('deviceKnown')) === true;
  };

  public storePersistentlyDeviceKnown = (deviceKnown: boolean): void => {
    localStorage.setItem('deviceKnown', JSON.stringify(deviceKnown).toString());
  };

  public storeDeviceKnown = (deviceKnown: boolean): void => {
    sessionStorage.setItem('deviceKnown', JSON.stringify(deviceKnown).toString());
  };

  public removeDeviceKnown = (): void => {
    localStorage.removeItem('deviceKnown');
  };

  public retrieveQrImage = (): string => {
    return JSON.parse(sessionStorage.getItem('qrImage'));
  };

  public storeQrImage = (qrImage: string): void => {
    sessionStorage.setItem('qrImage', JSON.stringify(qrImage).toString());
  };

  public removeQrImage = (): void => {
    sessionStorage.removeItem('qrImage');
  };

  public removelocalStorageData = (): void => {
    localStorage.removeItem('userPermission');
    localStorage.removeItem('devicePermission');
    localStorage.removeItem('deplyPermission');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('avatarUri');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('authToken');
    localStorage.removeItem('u');
    localStorage.removeItem('ai');
    localStorage.removeItem('ci');
    sessionStorage.removeItem('userPermission');
    sessionStorage.removeItem('devicePermission');
    sessionStorage.removeItem('deplyPermission');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('avatarUri');
    sessionStorage.removeItem('isAdmin');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('listPagination');
    sessionStorage.removeItem('listSorting');
    sessionStorage.removeItem('listTags');
    sessionStorage.removeItem('listSelection');
    sessionStorage.removeItem('qrImage');
    sessionStorage.removeItem('deviceKnown');
  };
  public retrieveSelectedTab = (): string => {
    return localStorage.getItem('selectedTab');
  };
  public removeSelectedTab = (): void => {
    localStorage.removeItem('selectedTab');
  };
  public storeSelectedTab = (indexTab: string): void => {
    localStorage.setItem('selectedTab', indexTab);
  };

  setApplicationId(id: string) {
    localStorage.setItem('applicationId', id);
  }
  setCompanyId(id: string) {
    sessionStorage.setItem('companyId', id);
  }

  getNoModalMaxUsage() {
    return localStorage.getItem('noModalMaxUsage') === 'true';
  }

  deleteCompanyId() {
    sessionStorage.removeItem('companyId');
  }

  getCompanyId() {
    return sessionStorage.getItem('companyId');
  }

  getApplicationId() {
    return localStorage.getItem('applicationId');
  }

  public setStoreSearch = (data): void => {
    localStorage.setItem('search', JSON.stringify(data));
  };
  public getStoreSearch = (): any => {
    return localStorage.getItem('search') !== undefined && localStorage.getItem('search') !== null
      ? JSON.parse(localStorage.getItem('search'))
      : '';
  };
  public removeStoreSearch = (): void => {
    localStorage.removeItem('search');
  };

  public setStorePersistentSearch = (data): void => {
    localStorage.setItem('persistent-search', JSON.stringify(data));
  };
  public getStorePersistentSearch = (): any => {
    return localStorage.getItem('persistent-search') !== undefined &&
      localStorage.getItem('persistent-search') !== null
      ? JSON.parse(localStorage.getItem('persistent-search'))
      : '';
  };
  public removeStorePersistentSearch = (): void => {
    localStorage.removeItem('persistent-search');
  };
  public resetBread = (): void => {
    let bread = [];
    localStorage.setItem('bread', JSON.stringify(bread));
  };
  public getBread = (): any => {
    return localStorage.getItem('bread') !== undefined && localStorage.getItem('bread') !== null
      ? JSON.parse(localStorage.getItem('bread'))
      : [];
  };
  public removeLastBread = (): void => {
    let bread = this.getBread();
    bread.pop();
    localStorage.setItem('bread', JSON.stringify(bread));
  };
  public setBread = (key: string, icon: string, value: string, id?: string): void => {
    let bread = this.getBread();
    let exits = bread.filter((element) => element.key === key);
    if (exits.length === 0) {
      bread.push({ key: key, icon: icon, value: value, id: id });
    } else {
      bread.forEach((element, index) => {
        if (element.key === key) {
          element.key = key;
          element.icon = icon;
          element.value = value;
          element.id = id;
        }
      });
    }
    localStorage.setItem('bread', JSON.stringify(bread));
  };

  getCompanyName() {
    return sessionStorage.getItem('companyName');
  }

  public removeBread = (): void => {
    localStorage.removeItem('bread');
  };
  setCompanyName(name: string) {
    sessionStorage.setItem('companyName', name);
  }
  removeGroup() {
    localStorage.removeItem('group');
    localStorage.removeItem('groupName');
  }
  getUrlReload() {
    const reloadUrl = sessionStorage.getItem('urlReload');
    if (reloadUrl) {
      return reloadUrl;
    }

    // Backward compatibility with legacy key.
    const legacyUrl = this.getUrl();
    if (!legacyUrl) {
      return null;
    }
    return legacyUrl.startsWith('/') ? legacyUrl : `/${legacyUrl}`;
  }
  setUrlReload(url: string) {
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    sessionStorage.setItem('urlReload', normalizedUrl);
  }
}
